import { render } from "./FirsttimerPerformanceReport.vue?vue&type=template&id=499614be&scoped=true"
import script from "./FirsttimerPerformanceReport.vue?vue&type=script&lang=js"
export * from "./FirsttimerPerformanceReport.vue?vue&type=script&lang=js"

import "./FirsttimerPerformanceReport.vue?vue&type=style&index=0&id=499614be&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499614be"]])

export default __exports__